/**
 * @internal
 */
/**
 * @internal
 */
function getRootAttribute(attributeName) {
  var _a;
  return (_a = document.documentElement) === null || _a === void 0 ? void 0 : _a.getAttribute(attributeName);
}
/**
 * @internal
 */
function setRootAttribute(attributeName, attributeValue) {
  if (document != null) {
    const root = document.documentElement;
    root.setAttribute(attributeName, attributeValue);
  }
}
/**
 * @internal
 */
function observeRootChange(attributeName, mutationsList) {
  var _a;
  for (const mutation of mutationsList) {
    if (mutation.attributeName === attributeName) {
      return (_a = document.documentElement) === null || _a === void 0 ? void 0 : _a.getAttribute(attributeName);
    }
  }
  return null;
}
/**
 * @internal
 */
function parseStringOrObject(value) {
  if (typeof value === 'string') {
    return JSON.parse(value);
  }
  return value;
}

export { getRootAttribute as g, observeRootChange as o, parseStringOrObject as p, setRootAttribute as s };
